/**
 * STORY#3197 专业版线上购买 —— 前端静态数据
 *
 * 接口已接入（payment 服务），套餐 / 订单 / 企业状态均来自后端；
 * 此处仅保留后端未提供的「9 大权益对比表」静态内容。
 * 若后续后端补权益接口，替换本文件即可。
 */

/**
 * 9 大权益对比表
 * category 相同的相邻行会做单元格合并渲染
 */
export const MOCK_RIGHTS = [
  {
    category: "生产经营管理",
    feature: "管理农场数量",
    trial: "限1个农场",
    pro: "无数量限制",
  },
  {
    category: "生产经营管理",
    feature: "协作人员人数",
    trial: "5名成员",
    pro: "无数量限制",
  },
  {
    category: "生产经营管理",
    feature: "承诺达标合格证开具",
    trial: "限试用50张",
    pro: "无数量限制",
  },
  {
    category: "智能设备接入",
    feature: "摄像头接入",
    trial: "",
    pro: "可接入海康威视、大华摄像头",
  },
  {
    category: "智能设备接入",
    feature: "主流物联网设备接入",
    trial: "",
    pro: "可接入左岸芯慧、新普慧、欧柯奇的物联网设备",
  },
  {
    category: "企业品牌定制",
    feature: "网页版企业个性化LOGO展示",
    trial: "",
    pro: "展示企业专属LOGO",
  },
  {
    category: "企业品牌定制",
    feature: "溯源扫码页面企业信息定制",
    trial: "",
    pro: "展示企业/品牌信息元素",
  },
  {
    category: "企业品牌定制",
    feature: "农场俯瞰图LOGO/水印自定义",
    trial: "",
    pro: "可自定义LOGO、去除水印导出俯瞰图",
  },
  {
    category: "溯源防伪升级",
    feature: "溯源数据区块链上链存证",
    trial: "",
    pro: "数据上链、防伪可核验",
  },
];
